import {
  MdDashboard,
  MdLock,
  MdFileCopy,
  MdDevices,
  MdPersonOutline,
  MdSupervisedUserCircle,
  MdLockOutline,
  MdOutlineNotifications,
  MdOutlineHome,
} from "react-icons/md";

// Auth Imports
import ForgotPasswordDefault from "views/auth/forgotPassword/ForgotPasswordDefault";
import SignInDefault from "views/auth/signIn/SignInDefault";
import SignUpDefault from "views/auth/signUp/SignUpDefault";
import VerificationDefault from "views/auth/verification/VerificationDefault";
import Devices from "views/admin/devices/index/page";
import Sites from "views/admin/sites/index/page";
import Profile from "views/admin/profile/page";
import ConfirmForgotPasswordDefault from "views/auth/confirmForgotPassword/ConfirmForgotPasswordDefault";
import LockDefault from "views/auth/lock/LockDefault";
import Users from "views/admin/users/page";
import User from "views/admin/users/user/page";
import Widgets from "views/admin/widgets/page";
import Device from "views/admin/devices/device/page";
import Site from "views/admin/sites/site/page";
import Support from "views/admin/support/page";
import AccountsDefault from "views/auth/accounts/AccountsDefault";
import Uvs from "views/admin/support/uvs/page";
import BulkUpload from "views/admin/support/bulkupload/page";
import Issues from "views/admin/devices/issues/page";
import Dashboards from "views/admin/dashboards/page";
import DevTools from "views/admin/devices/devtools/page";
import VerificationJobs from "views/admin/devices/verificationJobs/page";
import AccountManagement from "views/admin/support/accountManagement/page";
import TransferWizardPage from "views/admin/devices/transferwizard/page";
import Rates from "views/admin/sites/rates/page";
import AuditTools from "views/admin/support/audit/page";
import AuditTrail from "views/admin/support/auditTrail/page";
import HvacReport from "views/admin/support/hvacReport/page";
import Alerts from "views/admin/alerts/index/page";
import AlertDetails from "views/admin/alerts/details/page";
import Reports from "views/admin/reports/create/page";
import ReportsView from "views/admin/reports/view/page";

const routes = [
  {
    name: "Dashboards",
    layout: "/admin",
    path: "/dashboards",
    icon: <MdDashboard className="text-inherit h-5 w-5" />,
    collapse: false,
    component: <Dashboards />,
    roles: ["super", "administrator", "owner", "manager", "user"],
    flavours: ["atomsmartmetering", "precisionsmartmetering", "thermocloud"],
  },
  {
    name: "Devices",
    path: "/devices",
    icon: <MdDevices className="text-inherit h-5 w-5" />,
    collapse: true,
    roles: ["super", "administrator", "owner", "manager", "user"],
    flavours: ["atomsmartmetering", "precisionsmartmetering", "thermocloud"],
    items: [
      {
        name: "All Devices",
        layout: "/admin",
        path: "/devices/index",
        component: <Devices />,
        roles: ["super", "administrator", "owner", "manager", "user"],
        flavours: [
          "atomsmartmetering",
          "precisionsmartmetering",
          "thermocloud",
        ],
      },
      {
        name: "Device Actions",
        layout: "/admin",
        path: "/devices/issues",
        component: <Issues />,
        roles: ["super", "administrator", "owner", "manager", "user"],
        flavours: [
          "atomsmartmetering",
          "precisionsmartmetering",
          "thermocloud",
        ],
      },
      {
        name: "Installations",
        layout: "/admin",
        path: "/devices/verificationJobs",
        component: <VerificationJobs />,
        roles: ["super", "administrator"],
        flavours: [
          "atomsmartmetering",
          "precisionsmartmetering",
          "thermocloud",
        ],
      },
      {
        name: "Transfer Wizard",
        layout: "/admin",
        path: "/devices/transferwizard",
        component: <TransferWizardPage />,
        roles: ["super"],
        flavours: [
          "atomsmartmetering",
          "precisionsmartmetering",
          "thermocloud",
        ],
      },
    ],
  },
  {
    name: "Sites",
    path: "/sites",
    icon: <MdOutlineHome className="text-inherit h-5 w-5" />,
    collapse: true,
    roles: ["super", "administrator", "owner", "manager", "user"],
    flavours: ["atomsmartmetering", "precisionsmartmetering", "thermocloud"],
    items: [
      {
        name: "All Sites",
        layout: "/admin",
        path: "/sites/index",
        component: <Sites />,
        roles: ["super", "administrator", "owner", "manager", "user"],
        flavours: [
          "atomsmartmetering",
          "precisionsmartmetering",
          "thermocloud",
        ],
      },
      {
        name: "Rates",
        layout: "/admin",
        path: "/sites/rates",
        component: <Rates />,
        roles: ["super", "administrator"],
        flavours: ["atomsmartmetering", "precisionsmartmetering"],
      },
    ],
  },
  {
    name: "Alerts",
    layout: "/admin",
    path: "/alerts",
    icon: <MdOutlineNotifications className="text-inherit h-5 w-5" />,
    collapse: false,
    component: <Alerts />,
    roles: ["super", "administrator", "owner", "manager"],
    flavours: ["atomsmartmetering", "precisionsmartmetering", "thermocloud"],
  },
  {
    name: "Reports",
    path: "/reports",
    icon: <MdFileCopy className="text-inherit h-5 w-5" />,
    collapse: true,
    roles: ["super", "administrator", "owner", "manager"],
    flavours: ["atomsmartmetering", "precisionsmartmetering", "thermocloud"],
    items: [
      {
        name: "Create",
        layout: "/admin",
        path: "/reports/create",
        component: <Reports />,
        roles: ["super", "administrator", "owner", "manager"],
        flavours: [
          "atomsmartmetering",
          "precisionsmartmetering",
          "thermocloud",
        ],
      },
      {
        name: "View",
        layout: "/admin",
        path: "/reports/view",
        component: <ReportsView />,
        roles: ["super", "administrator", "owner", "manager"],
        flavours: [
          "atomsmartmetering",
          "precisionsmartmetering",
          "thermocloud",
        ],
      },
    ],
  },
  {
    name: "Users",
    layout: "/admin",
    path: "/users",
    icon: <MdSupervisedUserCircle className="text-inherit h-5 w-5" />,
    collapse: false,
    component: <Users />,
    roles: ["super", "administrator", "owner", "manager"],
    flavours: ["atomsmartmetering", "precisionsmartmetering", "thermocloud"],
  },
  {
    name: "Profile",
    layout: "/admin",
    path: "/profile",
    icon: <MdPersonOutline className="text-inherit h-5 w-5" />,
    collapse: false,
    component: <Profile />,
    roles: ["super", "administrator", "owner", "manager", "user"],
    flavours: ["atomsmartmetering", "precisionsmartmetering", "thermocloud"],
  },
  {
    name: "Support",
    layout: "/admin",
    path: "/support",
    icon: <MdLockOutline className="text-inherit h-5 w-5" />,
    collapse: false,
    component: <Support />,
    roles: ["super", "administrator"],
    flavours: ["atomsmartmetering", "precisionsmartmetering", "thermocloud"],
  },
  {
    name: "Widgets",
    layout: "/admin",
    path: "/widgets",
    icon: <MdLock className="text-inherit h-5 w-5" />,
    collapse: false,
    component: <Widgets />,
    roles: ["super"],
    flavours: ["atomsmartmetering", "precisionsmartmetering", "thermocloud"],
  },
];

export const allroutes = [
  {
    name: "User",
    layout: "/admin",
    path: "/users/user",
    component: <User />,
    navbar: "bg5",
    roles: ["super", "administrator", "owner", "manager"],
    flavours: ["atomsmartmetering", "precisionsmartmetering", "thermocloud"],
  },
  {
    name: "Device",
    layout: "/admin",
    path: "/devices/device",
    component: <Device />,
    navbar: "bg6",
    roles: ["super", "administrator", "owner", "manager", "user"],
    flavours: ["atomsmartmetering", "precisionsmartmetering", "thermocloud"],
  },
  {
    name: "Dev Tools",
    layout: "/admin",
    path: "/devices/devtools",
    component: <DevTools />,
    navbar: "bg3",
    roles: ["super", "administrator"],
    flavours: ["atomsmartmetering", "precisionsmartmetering", "thermocloud"],
  },
  {
    name: "Site",
    layout: "/admin",
    path: "/sites/site",
    component: <Site />,
    navbar: "bg4",
    roles: ["super", "administrator", "owner", "manager"],
    flavours: ["atomsmartmetering", "precisionsmartmetering", "thermocloud"],
  },
  {
    name: "Uvs",
    layout: "/admin",
    path: "/support/uvs",
    component: <Uvs />,
    navbar: "bg5",
    roles: ["super", "administrator"],
    flavours: ["atomsmartmetering", "precisionsmartmetering", "thermocloud"],
  },
  {
    name: "Audit Trail",
    layout: "/admin",
    path: "/support/auditTrail",
    component: <AuditTrail />,
    navbar: "bg5",
    roles: ["super", "administrator"],
    flavours: ["atomsmartmetering", "precisionsmartmetering", "thermocloud"],
  },
  {
    name: "Bulk Upload",
    layout: "/admin",
    path: "/support/bulkUpload",
    component: <BulkUpload />,
    navbar: "bg6",
    roles: ["super", "administrator"],
    flavours: ["atomsmartmetering", "precisionsmartmetering", "thermocloud"],
  },
  {
    name: "HVAC Report",
    layout: "/admin",
    path: "/support/hvacReport",
    component: <HvacReport />,
    navbar: "bg6",
    roles: ["super", "administrator"],
  },
  {
    name: "Audit Tools",
    layout: "/admin",
    path: "/support/audit",
    component: <AuditTools />,
    navbar: "bg1",
    roles: ["super", "administrator"],
    flavours: ["atomsmartmetering", "precisionsmartmetering", "thermocloud"],
  },
  {
    name: "Account Management",
    layout: "/admin",
    path: "/support/accountManagement",
    component: <AccountManagement />,
    navbar: "bg2",
    roles: ["super"],
    flavours: ["atomsmartmetering", "precisionsmartmetering", "thermocloud"],
  },
  {
    name: "Alert Details",
    layout: "/admin",
    path: "/alerts/details",
    component: <AlertDetails />,
    roles: ["super", "administrator", "owner", "manager"],
    navbar: "bg2",
    flavours: ["atomsmartmetering", "precisionsmartmetering", "thermocloud"],
  },
  // {
  //   name: "Transfer Wizard",
  //   layout: "/admin",
  //   path: "/support/transferwizard",
  //   component: <TransferWizardPage />,
  //   navbar: "bg2",
  //   roles: ["super"],
  // },
];

export const auth = [
  {
    name: "Sign In",
    layout: "/auth",
    path: "/sign-in/default",
    component: <SignInDefault />,
  },
  {
    name: "Sign Up",
    layout: "/auth",
    path: "/sign-up/default",
    component: <SignUpDefault />,
  },
  {
    name: "Verification",
    layout: "/auth",
    path: "/verification/default",
    component: <VerificationDefault />,
  },
  {
    name: "Forgot Password",
    layout: "/auth",
    path: "/forgot-password/default",
    component: <ForgotPasswordDefault />,
  },
  {
    name: "Confirm Forgot Password",
    layout: "/auth",
    path: "/confirm-forgot-password/default",
    component: <ConfirmForgotPasswordDefault />,
  },
  {
    name: "Lock",
    layout: "/auth",
    path: "/lock/default",
    component: <LockDefault />,
  },
  {
    name: "Accounts",
    layout: "/auth",
    path: "/accounts/default",
    component: <AccountsDefault />,
  },
];

export default routes;
